(function() {
  const path = window.location.pathname;

  
  const overrides = [
    {
      match: '/policies/shipping-policy',                
      newTitle: 'Política de envíos'
    },
    {
      match: '/policies/terms-of-service',
      newTitle: 'Términos de servicio'
    },
    {
      match: '/policies/refund-policy',
      newTitle: 'Política de devoluciones y Reembolsos'
    }
  ];

  
  const override = overrides.find(o => path.includes(o.match));
  if (!override) return;

  const newTitle = override.newTitle;

  
  document.title = newTitle;

  
  document.documentElement.style.visibility = 'hidden';

 
  const observer = new MutationObserver((mutations, obs) => {
    const h1 = document.querySelector('h1');
    if (h1) {
      h1.textContent = newTitle;
      document.documentElement.style.visibility = 'visible';
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
